import authenticationReducer from '@/store/authentication/authenticationSlice'
import featureFlagsReducer from '@/store/feature-flags/featureFlagsSlice'
import userReducer from '@/store/user/userSlice'
import tasksReducer from '@/store/tasks/tasksSlice'
import studentJobsReducer from '@/store/studentJobs/studentJobsSlice'
import employerReducer from '@/store/employer/employerSlice'
import immigrationReducer from '@/store/immigration/immigrationSlice'
import chatReducer from '@/store/chat/chatSlice'
import schoolAdminReducer from '@/store/schoolAdmin/schoolAdminSlice'
import subscriptionReducer from '@/store/subscription/subscriptionSlice'
import superAdminReducer from '@/store/superAdmin/superAdminSlice'
import { Action, AnyAction, ThunkAction, combineReducers, configureStore } from '@reduxjs/toolkit'
import { enableMapSet } from 'immer'
import { RESET_STORE_ACTION_TYPE } from '@/store/resetAction'

enableMapSet()

const appReducer = combineReducers({
  authentication: authenticationReducer,
  chat: chatReducer,
  employer: employerReducer,
  featureFlags: featureFlagsReducer,
  immigration: immigrationReducer,
  schoolAdmin: schoolAdminReducer,
  studentJobs: studentJobsReducer,
  subscription: subscriptionReducer,
  superAdmin: superAdminReducer,
  tasks: tasksReducer,
  user: userReducer,
})

/** On logout, every slice resets to its own initialState in one shot -
 * otherwise whichever persona was logged in (lawyer profile/appointments/
 * cases, employer data, chat conversations, etc.) stays in memory until
 * something happens to overwrite it, which a same-tab login as a different
 * account may not do for slices the new session never touches. */
const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: AnyAction): ReturnType<typeof appReducer> => {
  if (action.type === RESET_STORE_ACTION_TYPE) {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: rootReducer,
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
